import Styles from './Stepper.module.scss'
import { ChevronRight } from 'almanac-ui/icons'

export const Divider = () => (
  <div className={Styles.divider}>
    <ChevronRight />
  </div>
)
